import { AuthError } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { useRouteError } from 'react-router';
import { useTitle } from '../../common/hooks';
import { redirectRequest } from '../../configurations';
import { ConfirmationDialog } from '../shared-components';
import './ErrorPage.scss';

function isMsalError(error: unknown): error is AuthError {
  return error instanceof AuthError;
}

const ErrorPageImpl: React.FC = () => {
  const error = useRouteError();
  const { instance } = useMsal();
  const isAuthIssue = useMemo(() => isMsalError(error), [error]);

  useTitle('An Error Has Occurred');

  const handleReauthenticate = async (): Promise<void> => {
    await instance.clearCache();
    await instance.loginRedirect(redirectRequest);
  };

  return (
    <main className='error-page'>
      <h1>An error has occurred.</h1>
      <p>An unexpected error has occurred.</p>
      <ConfirmationDialog
        isOpen={isAuthIssue}
        isShowCloseDialog={false}
        dialogTitle='Your session needs to be refreshed'
        dialogSubtext='Your sign-in session has expired or requires re-consent. Please clear your cache and sign in again.'
        primaryButtonLabel='Ok'
        onPrimaryButtonClick={handleReauthenticate}
      />
    </main>
  );
}

export const ErrorPage = observer(ErrorPageImpl);
